import { Box, Stack, Typography } from '@mui/material';
import { IconArrowRight } from '@tabler/icons-react';

export const DefaultWarningContent = () => (
  <Box>
    <Typography variant="h4" sx={{ mb: 2 }}>
      Required Action:
    </Typography>
    <Typography variant="body1" sx={{ mb: 2 }}>
      You must move this stock lot to a correct location before you can proceed.
    </Typography>
    <Stack direction="row" spacing={1} alignItems="center">
      <Typography variant="body2" color="text.secondary">
        Scan a new location to move the stock lot
      </Typography>
      <IconArrowRight size={20} />
    </Stack>
  </Box>
);
